import { useIntl } from "react-intl";
import { format } from "date-fns";

import { VISUAL_COMMENT_TYPE, getVisualCommentMessageId } from "../../pages/dashboard/tabs/journal/comment-types";

import {
  IResponseVisualStationAlarmStatus,
  IResponseVisualTrainComments,
  IResponseJournalTrainTooltip,
} from "../../pages/dashboard/tabs/journal/interfaces";

export const MEASURES: Record<number, string> = {
  0: "Ручной ввод",
  1: "Общий уровень",
  2: "Пиковый уровень",
  3: "Эксцесс",
  4: "Амплитуда и Фаза",
  5: "Спектр",
  6: "Форма сигнала",
  8: "Скалярное значение",
  9: "Термограмма",
  10: "Минимальная толщина",
  11: "Толщина в сечении",
  12: "Анализ масла",
  13: "Состояние (толщина)",
  14: "Список",
  15: "Зазор",
};

export type TPointsTooltip = Record<number, Array<string>>;

export const useFormatTooltip = () => {
  const { formatMessage } = useIntl();

  return {
    formatTrainTooltip: (data: IResponseJournalTrainTooltip[]): TPointsTooltip => {
      const result: TPointsTooltip = {
        90: [],
        60: [],
        45: [],
      };

      data.forEach(({ AlarmStatus, Direction, MeasureType, NameMeasure, NamePoint, Value1 }) => {
        const namePoint = `${NamePoint}${
          Direction ? ` ${formatMessage({ id: `enums.pointDirection.${Direction}` })}` : ""
        }`;
        const measureName = MEASURES[MeasureType];
        const value = `${Value1.toFixed(2)} ${NameMeasure}`;
        result[AlarmStatus].push(`${namePoint}, ${measureName} (${value})`);
      });

      return result;
    },
    formatMeasureTooltip: (data: IResponseJournalTrainTooltip[], name: string): TPointsTooltip => {
      const result: TPointsTooltip = {
        90: [],
        60: [],
        45: [],
      };

      data
        .filter(({ Direction, NamePoint }) => {
          const namePoint = `${NamePoint}${
            Direction ? ` ${formatMessage({ id: `enums.pointDirection.${Direction}` })}` : ""
          }`;
          return name === namePoint;
        })
        .forEach(({ AlarmStatus, MeasureType, NameMeasure, Value1 }) => {
          const measureName = MEASURES[MeasureType];
          const value = `${Value1.toFixed(2)} ${NameMeasure}`;
          result[AlarmStatus].push(`${measureName} (${value})`);
        });

      return result;
    },
    formatVisualTooltipTrain: (data: IResponseVisualStationAlarmStatus[]): TPointsTooltip => {
      const result: TPointsTooltip = {
        90: [],
        60: [],
        45: [],
      };

      data.forEach(({ paramName, paramAnswer, alarmStatus }) => {
        if (result[alarmStatus]) {
          const formattedString = `${paramName}${paramAnswer ? ` (${paramAnswer})` : ""}`;
          result[alarmStatus].push(formattedString);
        } else {
          console.error(`Unknown alarmStatus: ${alarmStatus}`);
        }
      });

      return result;
    },

    formatVisualTooltipPoints: (data: IResponseVisualTrainComments): string => {
      // const formattedDate = data.date ? format(new Date(data.date), "dd.MM.yyyy HH:mm") : ""; // локальное время
      const formattedDate = data.date
        ? format(
            new Date(new Date(data.date).getTime() + new Date(data.date).getTimezoneOffset() * 60000),
            "dd.MM.yyyy HH:mm:ss",
          )
        : "";
      const userFullName = `${data.user?.surname ?? ""} ${data.user?.name ? data.user.name.charAt(0) + "." : ""}${
        data.user?.patronym ? data.user.patronym.charAt(0) + "." : ""
      }`.trim();
      const fileCommentMessageId = getVisualCommentMessageId(data.comments[0].commentType);
      const commentText =
        data.comments[0].commentType === VISUAL_COMMENT_TYPE.text
          ? data.comments[0].comment
          : fileCommentMessageId
            ? formatMessage({ id: fileCommentMessageId })
            : data.comments[0].comment;

      let tooltip = "";

      if (data.user.position != null) {
        const position = formatMessage({ id: `enums.userGroup.${data.user.position}` });
        tooltip += `${position}: `;
      }

      if (userFullName) {
        tooltip += `${userFullName}\n`;
      }

      if (data.paramAnswer) {
        tooltip += `${data.paramAnswer}\n\n\n\n`;
      }

      if (formattedDate) {
        tooltip += `${formattedDate} - `;
      }

      if (commentText) {
        tooltip += commentText;
      }

      return tooltip.trim();
    },
  };
};
